export default __webpack_public_path__ + "static/media/irishlife-glyph.b6264f3f.png";